import React from 'react';
import DownOutlined from '@ant-design/icons/lib/icons/DownOutlined';
import UpOutlined from '@ant-design/icons/lib/icons/UpOutlined';
import { Button } from 'antd';
import ImgTranscrip from '@/assets/transcrip.png';

interface IVideoTranscriptProps {
  transcripts: {
    language: string;
    transcripts: { time: string; text: string }[];
  }[];
}

const VideoTranscript: React.FunctionComponent<IVideoTranscriptProps> = ({
  transcripts,
}) => {
  const [state, setState] = React.useState({
    isTranscriptCollapsed: true,
    language: transcripts?.length > 0 ? transcripts[0].language : '',
  });
  const toggleTranscript = () => {
    setState({
      ...state,
      isTranscriptCollapsed: !state.isTranscriptCollapsed,
    });
  };
  const switchLanguage = (language: string) => {
    setState({
      ...state,
      language,
    });
  };
  return (
    <div className="video-transcript-area">
      <div className="video-transcript-title" onClick={toggleTranscript}>
        <img src={ImgTranscrip} alt="" />
        Transcript 字幕
        <Button
          onClick={toggleTranscript}
          className="transcript-button"
          type="text"
        >
          {state.isTranscriptCollapsed ? <DownOutlined /> : <UpOutlined />}
        </Button>
      </div>
      {!state.isTranscriptCollapsed ? (
        <div className="video-transcript-body">
          <div className="video-transcript-language">
            {transcripts?.map((t, idx) => (
              <div
                key={idx}
                className={`video-transcript-language-item ${
                  state.language === t.language ? 'selected' : ''
                }`}
                onClick={() => switchLanguage(t.language)}
              >
                {t.language}
              </div>
            ))}
          </div>
          <div className="video-transcript-content">
            {transcripts
              ?.find((t) => t.language === state.language)
              ?.transcripts.map((t, i) => (
                <div key={i} className="video-transcript-item">
                  {t.time && (
                    <div className="video-transcript-time">{t.time}</div>
                  )}
                  <div className="video-transcript-text">{t.text}</div>
                </div>
              ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default VideoTranscript;
